import { httpClient } from 'api/HttpClient';
import {
  CodeVerificationModel,
  LoginUserModel,
  ResponseLoginUserModel,
} from './slice/types';

export class LoginApi {
  LoginUser = (item: LoginUserModel) => {
    return httpClient.post<ResponseLoginUserModel>(
      `/api/Login/LoginUser`,
      item,
    );
  };
  SSOLoginUrl = (returnUrl: string) => {
    const data = { returnUrl: returnUrl };
    return httpClient.get<string>(`/api/Login/SSOLoginUrl`, data);
  };
  SendVerificationCode = () => {
    return httpClient.post<ResponseLoginUserModel>(
      `/api/Login/SendVerificationCode`,
    );
  };
  CodeVerification = (model: CodeVerificationModel) => {
    return httpClient.post<ResponseLoginUserModel>(
      `/api/Login/CodeVerification`,
      model,
    );
  };
}
